// imports
import merge from 'lodash/merge';
import DEFAULT_CONFIG from 'minsky-kit/js/Config';

export default merge(DEFAULT_CONFIG, {
    globals: GLOBALS, // passed by compiler

    app: {
        readyMessage: [
            '%cMade with %c♥ %cby %cwww.minsky.be',

            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'color: red; font-weight: bold; font-size: 14px',
            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'font-weight: bold; font-size: 12px; font-family: Poppins, Helvetica',
        ],
    },

    mqManager: {
        debounce: 250,

        queries: [
            { name: 'ready',            query: '(min-width: 0em)' },
            { name: 'mobileNavInit',    query: '(max-width: 46.875em)' },
            { name: 'mobileNavDestroy', query: '(min-width: 46.875em)' },
        ],
    },

    svgSprites: [
        `/themes/custom/${GLOBALS.theme}/assets/sprite.svg`,
    ],

    cookieConsent: {
        active:          false,
        loggedInUsers:   true,
        acceptAllButton: true,
        labels:          {
            title:       Drupal.t('minskyString.cookieConsent.labels.title'),
            description: Drupal.t('minskyString.cookieConsent.labels.description'),
            listTitle:   Drupal.t('minskyString.cookieConsent.labels.listTitle'),
            // Button labels based on state and preferences.
            button:      {
                // The default button label.
                default:   Drupal.t('minskyString.cookieConsent.button.default'),
                // The minimal button label.
                minimal:   Drupal.t('minskyString.cookieConsent.button.minimal'),
                // Shown when `acceptAllButton` is set, and no option is selected.
                acceptAll: Drupal.t('minskyString.cookieConsent.button.acceptAll'),
            },
            // ARIA labels to improve accessibility.
            aria: {
                button:    Drupal.t('minskyString.cookieConsent.aria.button'),
                tabList:   Drupal.t('minskyString.cookieConsent.aria.tabList'),
                tabToggle: Drupal.t('minskyString.cookieConsent.aria.tabToggle'),
            },
        },
        cookies:         [
            {
                id:          'functional',
                label:       Drupal.t('minskyString.cookieConsent.functionalCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.functionalCookie.description'),
                required:    true,
            },
            {
                id:          'marketing',
                label:       Drupal.t('minskyString.cookieConsent.marketingCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.marketingCookie.description'),
                checked:     false,
            },
            {
                id:          'social',
                label:       Drupal.t('minskyString.cookieConsent.socialCookie.label'),
                description: Drupal.t('minskyString.cookieConsent.socialCookie.description'),
                checked:     false,
            },
        ],
    },
});
